import $http from "@/api/index";
/**
 * 获取表单分页数据
 * @param {*} pagination 分页参数
 * @param {*} keyword 关键字搜索
 * @param {*} category 分组
 */
export function GetPageList(pagination, keyword, category) {
  let getUrl = {
    method: "GET",
    url: "/Custmerform/GetPageList",
    requestType: 1
  };
  let para = {
    pagination: pagination,
    keyword: keyword,
    category: category
  };
  return $http(getUrl, para);
}

/**
 * 获取表单模板数据
 * @param {*} pagination 分页参数
 * @param {*} schemeInfoId 模板ID
 */
export function GetSchemePageList(pagination, schemeInfoId) {
  let getUrl = {
    method: "GET",
    url: "Custmerform/GetSchemePageList",
    requestType: 1
  };
  let para = {
    pagination: pagination,
    schemeInfoId: schemeInfoId
  };
  return $http(getUrl, para);
}
/**
 * 获取设计表单数据
 * @param {*} keyValue 主键
 */
export function GetFormData(keyValue) {
  let getUrl = {
    method: "GET",
    url: "Custmerform/GetFormData",
    requestType: 1
  };
  let para = {
    keyValue: keyValue
  };
  return $http(getUrl, para);
}
/**
 * 获取自定义表单模板数据
 * @param {*} keyValue 主键
 */
export function GetSchemeEntity(keyValue) {
  let getUrl = {
    method: "GET",
    url: "Custmerform/GetSchemeEntity",
    requestType: 1
  };
  let para = {
    keyValue: keyValue
  };
  return $http(getUrl, para);
}
/**
 * 获取自定义表单列表
 */
export function GetSchemeInfoList() {
  let getUrl = {
    method: "GET",
    url: "Custmerform/GetSchemeInfoList",
    requestType: 1
  };
  let para = {};
  return $http(getUrl, para);
}

export function GetInstanceForm(schemeInfoId, processIdName, keyValue) {
  let getUrl = {
    method: "GET",
    url: "Custmerform/GetInstanceForm",
    requestType: 1
  };
  let para = {
    schemeInfoId: schemeInfoId,
    processIdName: processIdName,
    keyValue: keyValue
  };
  return $http(getUrl, para);
}

/**
 * 保存表单数据
 * @param {*} keyValue 主键
 * @param {*} schemeInfo 表单设计模板信息
 * @param {*} scheme 模板内容
 * @param {*} type 类型1.正式2.草稿
 */
export function SaveForm(keyValue, schemeInfo, scheme, type) {
  let getUrl = {
    method: "POST",
    url: `Custmerform/SaveForm?keyValue=${keyValue}&schemeInfo=${schemeInfo}&scheme=${scheme}&type=${type}`,
    requestType: 1
  };
  let para = {
    // keyValue:keyValue,
    // schemeInfo:schemeInfo,
    // scheme:scheme,
    // type:type
  };
  return $http(getUrl, para);
}

/**
 * 保存表单基本信息数据
 * @param {*} keyValue
 * @param {*} formSchemeInfo
 */
export function SaveSchemeInfoEntity(keyValue, formSchemeInfo) {
  let getUrl = {
    method: "POST",
    url: `Custmerform/SaveSchemeInfoEntity?keyValue=${keyValue}&formSchemeInfo=${formSchemeInfo}`,
    requestType: 1
  };
  let para = {};
  return $http(getUrl, para);
}

/**
 * 删除表单数据
 * @param {*} keyValue 主键
 */
export function DeleteForm(keyValue) {
  let getUrl = {
    method: "POST",
    url: `Custmerform/DeleteForm?keyValue=${keyValue}`,
    requestType: 1
  };
  return $http(getUrl, {});
}

/**
 * 更新表单模板版本
 * @param {*} schemeInfoId
 * @param {*} schemeId
 */
export function UpdateScheme(schemeInfoId, schemeId) {
  let getUrl = {
    method: "POST",
    url: `Custmerform/UpdateScheme`,
    requestType: 1
  };
  let para = {
    schemeInfoId: schemeInfoId,
    schemeId: schemeId
  };
  return $http(getUrl, para);
}

/**
 * 启用/停用表单
 * @param {*} keyValue 主键
 * @param {*} state 状态1启用0禁用
 */
export function UpDateSate(keyValue, state) {
  let getUrl = {
    method: "POST",
    url: `Custmerform/UpDateSate`,
    requestType: 1
  };
  let para = {
    keyValue: keyValue,
    state: state
  };
  return $http(getUrl, para);
}

/**
 * 保存自定义表单数据
 * @param {*} schemeInfoId 表单模板主键
 * @param {*} processIdName 流程关联字段名
 * @param {*} keyValue 数据主键值
 * @param {*} formData 自定义表单数据
 */
export function SaveInstanceForm(
  schemeInfoId,
  processIdName,
  keyValue,
  formData
) {
  let getUrl = {
    method: "POST",
    url: `Custmerform/SaveInstanceForm`,
    requestType: 1
  };
  let para = {
    schemeInfoId: schemeInfoId,
    processIdName: processIdName,
    keyValue: keyValue,
    formData: formData
  };
  return $http(getUrl, para);
}

/**
 * 删除自定义表单数据
 * @param {*} schemeInfoId 表单模板主键
 * @param {*} keyValue 数据主键值
 */
export function DeleteInstanceForm(schemeInfoId, keyValue) {
  let getUrl = {
    method: "POST",
    url: `Custmerform/DeleteInstanceForm`,
    requestType: 1
  };
  let para = {
    schemeInfoId: schemeInfoId,
    keyValue: keyValue
  };
  return $http(getUrl, para);
}
